export const config = {
  axisLines: { colour: "#e3e3e3" },
  radialLines: { colour: "#e3e3e3" },
  layout: {
    margin: {
      top: 100,
      right: 80,
      bottom: 40,
      left: 80,
    },
  },
  featureAlias: [
    "Straddle FV",
    "Up Tail / Down Tail",
    "Top Top Prox",
    "Bot Bot Prox",
    "Last Top Age",
    "Last Bot Age",
    "Age Top / Age Bot",
    "Avg Up Angle",
    "Avg Down Angle",
    "Wgt Up Angles",
    "EUB/ FV Put",
    "#Sup/ #Res",
    "Up Skew",
  ],
  featureStyle: {
    colour: "#000000",
    fontSize: 12,
    fontWeight: 400,
    hoverWeight: 700,
  },
  header: {
    colour: "#CBA266",
    fontSize: 14,
    fontWeight: 600,
    margin: { top: 20 },
  },
  legend: {
    active: true,
    colour: "#000000",
    fontSize: 14,
    fontWeight: 400,
    margin: { left: 0, top: 30 },
    lineWidth: 30,
    lineHeight: 4,
  },
  lineStyle: {
    colours: ["#7EC9E8", "green", "red"],
    dashed: ["", "4,2", "4,2"],
    strokeWidth: [0, 4, 4],
    fill: { colours: ["#7EC9E8", "none", "none"], opacity: [0.5, 0.5, 0.5] },
  },

  svg: { Background: "#ffffff", border: "none" },
};
